import { Dialog, Button } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';

const Modal = ({
  open,
  onOpenChange,
  onApply,
  onCancel,
  trigger,
  title = "Modal",
  description,
  children,
  cancelLabel,
  applyLabel,
  maxWidth = 500,
  showActions = true,
  disableApply = false
}) => {
  const { t } = useTranslation();
  const resolvedCancelLabel = cancelLabel ?? t('Cancel');
  const resolvedApplyLabel = applyLabel ?? t('Apply');

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      {trigger && (
        <Dialog.Trigger>
          {trigger}
        </Dialog.Trigger>
      )}
      <Dialog.Content style={{ maxWidth, maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}>
        <Dialog.Title>{title}</Dialog.Title>
        {description && (
          <Dialog.Description size="2" mb="4">
            {description}
          </Dialog.Description>
        )}

        <div style={{ overflowY: 'auto', flex: 1, minHeight: 0 }}>
          {children}
        </div>

        {showActions && (
          <div className="flex justify-end gap-2 mt-6">
            <Dialog.Close>
              <Button 
                variant="soft" 
                color="gray" 
                onClick={onCancel} 
                className="!bg-gray-100 !text-gray-700 hover:!bg-gray-200"
              >
                {resolvedCancelLabel}
              </Button>
            </Dialog.Close>
            <Button
              onClick={onApply}
              disabled={disableApply}
              className={`!font-semibold ${
                disableApply
                  ? '!bg-gray-300 !text-gray-500 !cursor-not-allowed'
                  : '!bg-black !text-white hover:!bg-gray-800'
              }`}
            >
              {resolvedApplyLabel}
            </Button>
          </div>
        )}
      </Dialog.Content>
    </Dialog.Root>
  );
};

export default Modal;

